import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Notification from '../Notification/Notification'; // Import the Notification component
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState(''); // State for email input
  const [loading, setLoading] = useState(false); // State for loading
  const [notification, setNotification] = useState({ message: '', type: '' }); // State for notification

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) {
      setNotification({ message: 'Please enter a valid email address.', type: 'error' });
      return;
    }

    setLoading(true); // Disable the button and show the spinner
    setNotification({ message: '', type: '' }); // Clear previous notifications

    try {
      const response = await fetch('https://sriharim.in/php/subscribe-newsletter.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Response: ${errorText}`);
      }

      const result = await response.json();

      if (result.status === 'success') {
        setNotification({ message: result.message, type: 'success' });
        setEmail(''); // Clear the input
        // Clear notification after 5 seconds
        setTimeout(() => setNotification({ message: '', type: '' }), 5000);
      } else {
        setNotification({ message: result.message || 'Failed to subscribe.', type: 'error' });
      }
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
      setNotification({ message: `An error occurred: ${error.message}`, type: 'error' });
    } finally {
      setLoading(false); // Re-enable the button
    }
  };

  const closeNotification = () => {
    setNotification({ message: '', type: '' });
  };

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-section footer-quick-links">
          <h3 className="footer-section-title">Quick Links</h3>
          <ul className="footer-links">
            <li>
              <NavLink to="/email-templates" className="footer-link">
                Email Templates
              </NavLink>
            </li>
            <li>
              <NavLink to="/websites" className="footer-link">
                Websites
              </NavLink>
            </li>
            <li>
              <NavLink to="/services" className="footer-link">
                Services
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className="footer-link">
                Contact
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="footer-section footer-social">
          <h3 className="footer-section-title">Follow Me</h3>
          <div className="footer-social-links">
            <a
              href="https://www.linkedin.com/in/srihari-muppalla/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
            >
              LinkedIn
            </a>
            <a
              href="https://github.com/srihariMuppalla"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
            >
              GitHub
            </a>
            <a
              href="https://x.com/srihariM64"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
            >
              Twitter
            </a>
            <a
              href="https://www.instagram.com/srihari_developer/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
            >
              Instagram
            </a>
          </div>
        </div>

        <div className="footer-section footer-newsletter">
          <h3 className="footer-section-title">Subscribe to Newsletter</h3>
          <p className="footer-newsletter-subtitle">
            Stay updated with the latest web development tips, email marketing strategies, and portfolio updates.
          </p>
          {/* Notification Display */}
          <Notification
            message={notification.message}
            type={notification.type}
            onClose={closeNotification}
          />
          <form className="footer-subscribe-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Enter your email"
              className="footer-subscribe-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button
              type="submit"
              className="footer-subscribe-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                </>
              ) : (
                'Subscribe'
              )}
            </button>
          </form>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          © {new Date().getFullYear()} Srihari Muppalla. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;